// The `FaqsAccordian` component renders a list of FAQs using collapsible accordion sections for
// better user interaction. Each FAQ's question serves as the header, and the corresponding answer
// is revealed upon expansion. The component also includes links for additional inspiration and
// account creation, enhancing navigation and user engagement.

import React, { useState } from 'react';
import AccordionBtn from 'components/commercetools-ui/atoms/accordion';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { ServiceFAQ } from 'types/next';
import { useRouter } from 'next/navigation';
import { useAccount } from 'frontastic';
import { MarkDownDescription } from 'components/commercetools-ui/atoms/markdown/markdown';

type FAQSContent = {
  faqs: ServiceFAQ[];
};

const FaqsAccordian = ({ faqs }: FAQSContent) => {
  const { loggedIn } = useAccount();
  const router = useRouter();

  return (
    <div className="mt-70 border-t border-[#d1c9c4]">
      {faqs &&
        faqs.map((faq: ServiceFAQ, index: number) => {
          return (
            <AccordionBtn
              variant="plusAndMinus"
              className="items-center border-b border-[#d1c9c4] py-15 text-16 font-semibold hover:text-[#127e57]"
              closedSectionTitle={faq.question}
              panelClassName="text-primary-black pt-10"
              key={index}
            >
              <MarkDownDescription markdownText={faq.answer} />
            </AccordionBtn>
          );
        })}
      <div className="mt-15 flex items-center justify-between">
        <p className="flex cursor-pointer items-end whitespace-nowrap text-16 font-medium text-[#127e57]">
          Inspiration & advice
          <ChevronRightIcon className="ml-5 h-15 w-15 text-[#127e57]" />
        </p>
        <p
          className="flex cursor-pointer items-end whitespace-nowrap text-16 font-medium text-[#127e57]"
          onClick={() => {
            router.push(loggedIn ? '/account' : '/login');
          }}
        >
          Create a account
          <ChevronRightIcon className="ml-5 h-15 w-15 text-[#127e57]" />
        </p>
      </div>
    </div>
  );
};

export default FaqsAccordian;
